//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'

//
import TransferBetweenWarehouseModel from '@/models/Warehouse/WhTransferBetweenWarehouse'
import Translator from '@/services/translator'
import fields from './fields'

//
export default {
    name: 'transfer-between-warehouse-reception',
    components: {
        'model-form': ModelForm,
    },
    computed: {
        /**
         *
         */
        formProps() {
            return {
                editable: false,
                fields: fields({ g_branch_office_id: 1 }),
                loading: this.formBusy,
                switchEdit: this.formData.can_receive,
            }
        },

        //
        ...mapState('AuthModule', {
            user: 'user',
        }),

        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    data() {
        return {
            formBusy: false,
            formData: {},
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'transfer-between-warehouse' })
        },

        /**
         *
         */
        reset() {
            this.formBusy = true
            TransferBetweenWarehouseModel.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },

        /**
         *
         */
        setFormData(model) {
            this.formBusy = false
            this.formData = model.reset({ user: this.user })
        },

        /**
         *
         */
        showError(error) {
            this.showSnackbar(
                'error',
                'Error.',
                Translator(TransferBetweenWarehouseModel, error.response.data)
            )
        },

        /**
         *
         */
        showSnackbar(type, title, message, callback) {
            this.initSnackbar(this.fillSnack(type, title, message))
            if (typeof callback === 'function') callback()
        },

        /**
         *
         */
        showSuccess() {
            this.showSnackbar(
                'success',
                'Éxito.',
                'Recepcion de guía de intercambio actualizada.',
                this.redirect
            )
        },

        /**
         *
         */
        submit() {
            this.$refs.form.setWait(true).then(this.receive)
        },

        /**
         *
         */
        receive(model) {
            model
                .receive()
                .then(this.showSuccess)
                .catch(this.showError)
                .then(this.$refs.form.setWait)
        },
    },
    beforeMount() {
        this.setTitleTopBar('Recepcion de guía de intercambio')
    },
    mounted() {
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('EXECUTE_RECEIVE_TRANSFER_BETWEEN_WAREHOUSE'))
                ctx.$router.push('/')
        })
    },
}
